import React from "react";
import "./testimonials.css";
import JOACHIM_PHOTO from "../images/team/joachim.jpg";
import DAN_PHOTO from "../images/team/dan.jpg";

const Testimonials = () => {
  const testimonialsData = [
    {
      id: 1,
      photo: JOACHIM_PHOTO,
      name: "Prof. Dr. Joachim Hornegger",
      designation: "President of FAU, #1 Innovator University of Europe",
      content:
        "We have experienced an unprecedented change in the Ed-Tech space over the last 4 years, first with covid and now with the emergence of Artificial Intelligence. Online learning will never be the same again. There is a new era of learning and teaching. Smart tools are the future, and we must do it now, not 5 years later.",
      flag: false,
    },
    {
      id: 2,
      photo: DAN_PHOTO,
      name: "Prof. Dan Moshavi",
      designation:
        "Dean, San Diego State University, Fowler College of Business",
      content: "Copal has created the smart tools for the future of education.",
      flag: true,
    },
  ];

  return (
    <div className="testimonials-container">
      {testimonialsData.map((testimonial) => (
        <div
          key={testimonial.id}
          className="testimonial"
          style={{
            marginLeft: testimonial.flag ? "35%" : 0,
            marginRight: !testimonial.flag ? "25%" : 0,
            marginTop: !testimonial.flag ? "10%" : "0px",
          }}
        >
          <div className="testimonial-photo-container">
            <img
              src={testimonial.photo}
              alt={testimonial.name}
              className="testimonial-photo"
            />
          </div>
          <div className="testimonial-content">
            <div className="testimonial-author">
              <div className="testimonial-name">{testimonial.name}</div>
              <div className="testimonial-designation">
                {testimonial.designation}
              </div>
            </div>
            <div className="testimonial-text">
              <span className="quotation-mark">"</span>
              {`${testimonial.content}`}
              <span className="quotation-mark">"</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Testimonials;
